// src/pages/Acts/ReturnActsPage.jsx
import React, { useState } from 'react';
import { useQuery } from '@tanstack/react-query';
import {
  Table, Input, Space, Tag, Typography,
  Card, Button, Tooltip
} from 'antd';
import {
  SearchOutlined, ReloadOutlined,
  FileOutlined, DownloadOutlined
} from '@ant-design/icons';
import { returnActsAPI } from '../../api/client';

const { Title, Text } = Typography;

function formatDate(str) {
  if (!str) return '—';
  return new Date(str).toLocaleDateString('ru-RU');
}

export default function ReturnActsPage() {
  const [search, setSearch] = useState('');

  const { data, isLoading, refetch } = useQuery({
    queryKey: ['return-acts-all'],
    queryFn:  () => returnActsAPI.list().then(r => r.data),
  });

  const items = (data || []).filter(a => {
    if (!search) return true;
    const q = search.toLowerCase();
    return (
      a.employee?.toLowerCase().includes(q) ||
      a.act_number?.toLowerCase().includes(q) ||
      a.company?.toLowerCase().includes(q)
    );
  });

  const columns = [
    {
      title: 'Номер', dataIndex: 'act_number', key: 'act_number', width: 100,
      render: (v) => <Text strong style={{ fontFamily: 'monospace' }}>{v}</Text>,
    },
    {
      title: 'Дата', dataIndex: 'act_date', key: 'act_date', width: 110,
      render: (v) => formatDate(v),
    },
    {
      title: 'Сотрудник', dataIndex: 'employee', key: 'employee', width: 220,
      render: (v) => <Text strong>{v}</Text>,
    },
    {
      title: 'Компания', dataIndex: 'company', key: 'company', width: 150,
      render: (v) => <Tag>{v}</Tag>,
    },
    {
      title: 'Позиций', dataIndex: 'items_count', key: 'items_count', width: 80, align: 'center',
      render: (v) => <Tag color="orange">{v}</Tag>,
    },
    {
      title: 'Язык', dataIndex: 'language', key: 'language', width: 70, align: 'center',
      render: (v) => <Tag color={v === 'sr' ? 'purple' : 'default'}>{v?.toUpperCase()}</Tag>,
    },
    {
      title: 'Сформирован', dataIndex: 'created_at', key: 'created_at', width: 140,
      render: (v) => v ? new Date(v).toLocaleString('ru-RU', {
        day: '2-digit', month: '2-digit', year: 'numeric',
        hour: '2-digit', minute: '2-digit',
      }) : '—',
    },
    {
      title: '', key: 'actions', width: 90, fixed: 'right',
      render: (_, record) => (
        <Space>
          <Tooltip title="Открыть на Drive">
            <Button
              type="text" size="small" icon={<FileOutlined />}
              disabled={!record.drive_url}
              onClick={() => window.open(record.drive_url, '_blank')}
            />
          </Tooltip>
          <Tooltip title="Скачать PDF">
            <Button
              type="text" size="small" icon={<DownloadOutlined />}
              disabled={!record.drive_file_id}
              onClick={() => window.open(
                `https://drive.google.com/uc?export=download&id=${record.drive_file_id}`,
                '_blank'
              )}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Title level={4} style={{ margin: 0 }}>Журнал актов возврата</Title>
        <Button icon={<ReloadOutlined />} onClick={() => refetch()}>Обновить</Button>
      </div>

      <Card size="small" style={{ marginBottom: 16 }}>
        <Input
          placeholder="Поиск по сотруднику, номеру, компании"
          prefix={<SearchOutlined />}
          style={{ width: 360 }}
          allowClear
          onChange={(e) => setSearch(e.target.value)}
        />
      </Card>

      <Card size="small">
        <Table
          dataSource={items}
          columns={columns}
          rowKey="id"
          loading={isLoading}
          size="small"
          pagination={{
            pageSize: 50,
            showSizeChanger: true,
            showTotal: (t) => `Всего ${t} актов`,
          }}
        />
      </Card>
    </div>
  );
}